import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import TitledMultiDropdown from "components/TitledMultiDropdown";

import styles from "forms/forms.css";

const MultiDropdownField = (props) => {
  const {
    align,
    field: { name, value },
    form: { errors, setFieldValue, submitCount },
    inputComponent,
    inputComponentProps,
    isDisabled,
    isEdit,
    isInline,
    keyExtractor,
    label,
    onEdit,
    placeholder,
    valueExtractor,
    values,
  } = props;

  return (
    <div
      className={cx(styles.field, {
        [styles.inline]: isInline,
        [styles.disabled]: isDisabled,
      })}
    >
      <TitledMultiDropdown
        align={align}
        inputComponent={inputComponent}
        inputComponentProps={inputComponentProps}
        isEdit={isEdit}
        isRequired={!!submitCount && errors[name]}
        keyExtractor={keyExtractor}
        onEdit={onEdit}
        onSelect={(v) => setFieldValue(name, v)}
        placeholder={placeholder}
        selectedValues={value || []}
        title={label}
        valueExtractor={valueExtractor}
        values={values}
      />
    </div>
  );
};
const dropdownTypes = [PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.element];

MultiDropdownField.propTypes = {
  align: PropTypes.oneOf(["left", "right"]),
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.array,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    submitCount: PropTypes.number,
    setFieldValue: PropTypes.func,
  }),
  inputComponent: PropTypes.func,
  keyExtractor: PropTypes.func,
  label: PropTypes.string,
  onEdit: PropTypes.func,
  placeholder: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.oneOfType(dropdownTypes)).isRequired,
  valueExtractor: PropTypes.func,
  isEdit: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isInline: PropTypes.bool,
  inputComponentProps: PropTypes.object, // eslint-disable-line
};

MultiDropdownField.defaultProps = {
  isEdit: true,
  keyExtractor: (v) => v,
  valueExtractor: (v) => v,
};

export default MultiDropdownField;
